/*
 * Jira Ticket:
 * Created Date: Tue, 17th Mar 2020, 15:42:40 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { cloneElement } from 'react';
import { Button } from '@material-ui/core';
import classnames from 'classnames';
import { defaultButton } from 'styles';

const sanitizeRestProps = ({
  basePath,
  handleSubmit,
  record,
  resource,
  undoable,
  hasCreate,
  hasEdit,
  hasList,
  hasShow,
  ...rest
}) => rest;

const TextButton = props => {
  const { label, icon, ...rest } = props;
  const classes = defaultButton();
  return (
    <Button className={classes.root} {...sanitizeRestProps(rest)}>
      {icon &&
        cloneElement(icon, {
          className: classnames(classes.leftIcon, classes.icon),
        })}
      {label}
    </Button>
  );
};

export default TextButton;
